export default {
  招商招标系统: '招商招标系统',
  个人: '个人',
  注册账户: '注册账户',
  '(金币)': '(金币)',
  '总金额(金币)': '总金额(金币)',
  '充值金额(金币)': '充值金额(金币)',
  '收入金额(金币)': '收入金额(金币)',
  已为您匹配潜在采购商: '已为您匹配潜在采购商',
  云招标管理: '云招标管理',
  云供应管理: '云供应管理',
  云招商管理: '云招商管理',
  '(敬请期待)': '(敬请期待)',
  采购系统: '采购系统',
  我的客户数据: '我的客户数据',
  获客工具: '获客工具',
  '云优惠(发券)': '云优惠(发券)',
  '我的优惠券（领取）': '我的优惠券（领取）',
  账号设置: '账号设置',
  '立即申请企业认证,获取更多企业服务': '立即申请企业认证,获取更多企业服务',
  '个人用户不支持添加到通讯录,请申请企业认证再操作！': '个人用户不支持添加到通讯录,请申请企业认证再操作！',
  去申请企业认证: '去申请企业认证',
  '个人用户无法查阅招标信息,请申请成为企业用户!': '个人用户无法查阅招标信息,请申请成为企业用户!',
  '您当前为[基础版],聊天记录最多可保存30天,若保存更长时间,请升级企业会员套餐！':
    '您当前为[基础版],聊天记录最多可保存30天,若保存更长时间,请升级企业会员套餐！',
  去升级: '去升级',
  去升级企业会员套餐: '去升级企业会员套餐',
  '云展动力平台提供洽谈消息未读短信提醒功能,客户咨询永不落空,快速响应客户咨询需求,您当前为[基础版],若想使用可升级企业会员套餐':
    '云展动力平台提供洽谈消息未读短信提醒功能,客户咨询永不落空,快速响应客户咨询需求,您当前为[基础版],若想使用可升级企业会员套餐',
  '云展动力平台提供洽谈消息未读短信提醒功能,客户咨询永不落空,快速响应客户咨询需求,您当前为个人用户,请立即申请企业认证':
    '云展动力平台提供洽谈消息未读短信提醒功能,客户咨询永不落空,快速响应客户咨询需求,您当前为个人用户,请立即申请企业认证',
  '您当前的身份为个人用户,请升级成为企业用户,再报名参展!': '您当前的身份为个人用户,请升级成为企业用户,再报名参展!',
  '恭喜您注册成功,在云展动力平台您可以免费搜索到全球各地热门供应商。若您是企业用户,还可利用平台的企业云展系统、大数据获客系统、云上展会系统等实现精准获客,促进企业发展.':
    '恭喜您注册成功,在云展动力平台您可以免费搜索到全球各地热门供应商。若您是企业用户,还可利用平台的企业云展系统、大数据获客系统、云上展会系统等实现精准获客,促进企业发展.',
  '有效期至 YYYY-MM-nn': '有效期至 YYYY-MM-nn',
  '客户详情查看仅开通企业会员套餐的用户使用,请开通企业会员套餐再查看！':
    '客户详情查看仅开通企业会员套餐的用户使用,请开通企业会员套餐再查看！',
  '员工详情查看仅开通企业会员套餐的用户使用,请开通企业会员套餐再查看！':
    '员工详情查看仅开通企业会员套餐的用户使用,请开通企业会员套餐再查看！',
  '客户在线洽谈功能仅开通企业会员套餐的用户使用,请开通企业会员套餐再查看！':
    '客户在线洽谈功能仅开通企业会员套餐的用户使用,请开通企业会员套餐再查看！',
  '添加手机号码/邮箱': '添加手机号码/邮箱',
  基础版: '基础版',
  标准版: '标准版',
  升级版: '升级版',
  旗舰版: '旗舰版',
  尊享版: '尊享版',
  免费注册: '免费注册',
  当前的套餐: '当前的套餐',
  升级为: '升级为',
  云展系统: '云展系统',
  全球即时洽谈: '全球即时洽谈',
  智能名片: '智能云展',
  智能名片500张: '智能云展500张',
  智能名片5万张: '智能云展5万张',
  智能名片10万张: '智能云展10万张',
  智能名片25万张: '智能云展25万张',
  智能名片150万张: '智能云展150万张',
  员工账号30个: '员工账号30个',
  员工账号100个: '员工账号100个',
  员工账号500个: '员工账号500个',
  员工账号1000个: '员工账号1000个',
  员工账号2000个: '员工账号2000个',
  招标查询100次: '招标查询100次',
  精准邀约100家: '精准邀约100家',
  商机提醒100家: '商机提醒100家',
  招标查询1000次: '招标查询1000次',
  招标查询500次: '招标查询500次',
  招标查询3000次: '招标查询3000次',
  招标查询1万次: '招标查询1万次',
  招标查询6万次: '招标查询6万次',
  精准邀约1万家: '精准邀约1万家',
  精准邀约3万家: '精准邀约3万家',
  精准邀约12万家: '精准邀约12万家',
  精准邀约30万家: '精准邀约30万家',
  商机提醒: '商机提醒',
  商机提醒1000条: '商机提醒1000条',
  商机提醒5000条: '商机提醒5000条',
  商机提醒2万条: '商机提醒2万条',
  商机提醒10万条: '商机提醒10万条',
  产品3D扫描1件: '产品3D扫描1件',
  产品3D扫描3件: '产品3D扫描3件',
  产品3D扫描5件: '产品3D扫描5件',
  室内3D扫描3个: '室内3D扫描3个',
  室内3D扫描5个: '室内3D扫描5个',
  '3D航拍扫描1个': '3D航拍扫描1个',
  限时优惠: '限时优惠',
  线索推送: '线索推送',
  云端完整构筑企业全貌: '云端完整构筑企业全貌',
  企业子账号数: '企业子账号数',
  立即邀请: '立即邀请',
  '还没有同事？立即邀请同事立刻加入公司,共创辉煌！': '还没有同事？立即邀请同事立刻加入公司,共创辉煌！',
  子账户已获取的客户数: '子账户已获取的客户数',
  云端完整构筑企业全貌Tip1: '快速构建数字工厂的3D可视化工具<br/>实景克隆多维展示,全方位打造企业展示系统',
  云端完整构筑企业全貌Tip2: '客户云端观看企业实况<br/>720度全方位看产品,巡产线、看实力',
  云端完整构筑企业全貌Tip3: '助力企业数字化转型升级,增效降本管理现实世界',
  全球客户畅聊无障碍: '全球客户畅聊无障碍',
  全球客户畅聊无障碍Tip1: '1V1实时音视频,稳定流畅,高清音画质,支持多语言聊天',
  全球客户畅聊无障碍Tip2: '全球多节点覆盖,消息实时送达,低成本低延时',
  全球客户畅聊无障碍Tip3:
    '丰富消息类型,满足各种应用场景：支持文本、图片、表情、音视频、地理位置、附件等消息类型,历史消息记录支持漫游',
  '智能名片,连接十亿用户': '智能名片,连接十亿用户',
  智能名片TIP1: '个性化智能名片,打造专属IP形象',
  智能名片TIP2: '全方位立体展示企业及个人信息, 支持文字、图片、视频等丰富展示',
  智能名片TIP3: '助力客户快速直观了解个人、企业、产品,提高客户信任度,让营销更高效',
  数据引擎高效获客: '数据引擎高效获客',
  数据引擎高效获客Tip1: '数据引擎汇聚线上线下亿级客户资源,数据不再割裂',
  数据引擎高效获客Tip2: '云计算整合、清洗、合并、分析全渠道企业信息',
  数据引擎高效获客Tip3: '自定义邀约内容,个性化一键触达,高效获客',
  精准商机匹配: '精准商机匹配',
  精准商机匹配Tip1: '精准用户画像分层:通过客户画像背后的多级维度,智能化圈群分组',
  精准商机匹配Tip2: '千人千面智能分析：根据用户画像标签,精准推荐用户感兴趣内容',
  精准商机匹配Tip3: '精准推送商机：智能匹配供需关系,双向选择,各取所需,互相成就',
  '千万商机0延误,0遗漏': '千万商机0延误,0遗漏',
  商机提醒Tip1: '发现商机信息短信、邮件及时强提醒',
  商机提醒Tip2: '建立快速沟通的桥梁,及时满足客户需求,有效提升客户转化率',
  商机提醒Tip3: '提升客户服务满意度,创造主动营销价值',
  点击了解更多权益: '点击了解更多权益',
  客服电话: '客服电话',
  '搜索未来商机,抢占获客先机': '搜索未来商机,抢占获客先机',
  '100000+企业正在使用云展动力获客': '100000+企业正在使用云展动力获客',
  '企业会员套餐需要企业主账号开通,子账号无权开通！请联系您的企业管理员进行续费或升级,您的企业管理员为':
    '企业会员套餐需要企业主账号开通,子账号无权开通！请联系您的企业管理员进行续费或升级,您的企业管理员为',
  '您已申请企业认证,正在审核中': '您已申请企业认证,正在审核中！',
  '免费查阅招标信息条数已用光,若想查看更多招标信息,请升级企业会员套餐!':
    '免费查阅招标信息条数已用光,若想查看更多招标信息,请升级企业会员套餐!',
  预览云展系统: '预览云展系统',
  基础版升级提示: '您当前企业会员套餐为[基础版],最多可生成1个子账号,若想生成更多子账号,可升级企业会员套餐',
  商务版升级提示: '您当前企业会员套餐为[商务版],最多可生成10个子账号,若想生成更多子账号,可升级企业会员套餐',
  旗舰版升级提示: '您当前企业会员套餐为[旗舰版],最多可生成30个子账号,若想生成更多子账号,可升级企业会员套餐',
  元宇宙版升级提示: '您当前企业会员套餐为[元宇宙版],最多可生成100个子账号,如需增加子账号，请联系客服进行咨询!',

  '平台冻结,指的是企业已购买的企业会员套餐有效期已过,不再续费或开通了更低的企业会员套餐,超过企业会员套餐内的子账号数量的部分子账号会自动被平台冻结,您可升级更高的企业会员套餐进行解冻':
    '平台冻结,指的是企业已购买的企业会员套餐有效期已过,不再续费或开通了更低的企业会员套餐,超过企业会员套餐内的子账号数量的部分子账号会自动被平台冻结,您可升级更高的企业会员套餐进行解冻',
  资料审核中: '资料审核中',
  已为您匹配潜在参展商: '已为您匹配潜在参展商',
  企业中心: '企业中心',
  完善企业资料: '完善企业资料',
  升级套餐: '升级套餐',
  '您好！您现在的身份为个人用户,无法享受企业服务,请申请认证！':
    '您好！您现在的身份为个人用户,无法享受企业服务,请申请认证！',
  为您的企业选择最佳获客方案: '为您的企业选择最佳获客方案',
  尊享: '尊享',
  项权益: '项权益',
  当前套餐: '当前套餐',
  获客利器: '获客利器',
  我的企业管理: '我的企业管理',
  发短信: '发短信',
  猜您喜欢的云上展览: '猜您喜欢的云上展览',
  猜您喜欢的云产品: '猜您喜欢的云产品',
  '主账号(企业管理者)': '主账号(企业管理者)',
  '(企业管理者)': '(企业管理者)',
  云上展览系统: '云上展览系统',
  客户管理系统: '客户管理系统',
  财务中心: '财务中心',
  企业获客数: '企业获客数',
  员工分享数: '员工分享数',
  客户查看数: '客户查看数',
  客户转发数: '客户转发数',
  客户点赞数: '客户点赞数',
  完善: '完善',
  Ta感兴趣标签: 'Ta感兴趣标签',
  员工营销数据: '员工营销数据',
  企业通讯录容量: '企业通讯录容量',
  员工已使用数量: '员工已使用数量',
  已超过通讯录容量: '已超过通讯录容量',
  云展动力智能获客方案套餐权限服务列表: '云展动力智能获客方案套餐权限服务列表',
  浏览我的企业: '浏览我的企业',
  // upgradevip 模块
  填写您的企业: '填写您的企业',
  购买版本: '购买版本',
  限时折扣: '限时折扣',
  '元/年': '元/年',
  免费体验: '免费体验',
  提交订单: '提交订单',
  支付订单: '支付订单',
  企业会员套餐: '企业会员套餐',
  套餐期限: '套餐期限',
  支付成功起一年: '支付成功起一年',
  订单金额: '订单金额',
  对公转账: '对公转账',
  微信支付: '微信支付',
  '实付:': '实付:',
  '已优惠:': '已优惠:',
  支付即代表您同意: '支付即代表您同意',
  '《云展动力VIP会员服务协议》': '《云展动力VIP会员服务协议》',
  进行对公转账: '进行对公转账',
  提示: '提示',
  '该企业已注册, 请确认名称是否正确': '该企业已注册, 请确认名称是否正确',
  '名字有误, 重新输入': '名字有误, 重新输入',
  '名字正确,联系客服': '名字正确,联系客服',
  '您有未支付的订单, 是否前往支付?': '您有未支付的订单, 是否前往支付?',
  查看待支付订单: '查看待支付订单',
  取消并创建新订单: '取消并创建新订单',
  '您有待审核的订单, 请等待审核通过后再购买': '您有待审核的订单, 请等待审核通过后再购买',
  请输入企业名称: '请输入企业名称',
  您尚未支付成功: '您尚未支付成功',
  // btmInfo 和 fixedRightCont
  '咨询产品、报价及更多细节？请联系我们': '咨询产品、报价及更多细节？请联系我们',
  在线咨询: '在线咨询',
  微信咨询: '微信咨询',
  关注我们: '关注我们',
  // firstLogin 模块
  加入已有企业: '加入已有企业',
  您的姓名: '您的姓名',
  企业名称: '企业名称',
  企业地址: '企业地址',
  修改企业名称: '修改企业名称',
  提交: '提交',
  '有疑问? 联系客服': '有疑问? 联系客服',
  请输入姓名: '请输入姓名',
  创建: '创建',
  创建成功: '创建成功',
  // order 模块
  全部订单: '全部订单',
  待支付: '待支付',
  审核中: '审核中',
  已完成: '已完成',
  商品信息: '商品信息',
  订单类型: '订单类型',
  订单状态: '订单状态',
  操作: '操作',
  '订单号:': '订单号:',
  立即付款: '立即付款',
  去转账: '去转账',
  取消订单: '取消订单',
  重新下单: '重新下单',
  申请合同: '申请合同',
  查看合同: '查看合同',
  申请发票: '申请发票',
  取消成功: '取消成功',
  立即支付: '立即支付',
  联系客服: '联系客服',
  已完成转账: '已完成转账',
  // wechatPayModal
  距离二维码过期还剩: '距离二维码过期还剩',
  二维码已过期请刷新: '二维码已过期请刷新',
  刷新: '刷新',
  使用微信扫码支付: '使用微信扫码支付',
}
